import { memo } from 'preact/compat';
import { getImageUri } from '@/utils';

const allowedImageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'svg'];
const allowedVideoRegex =
	/^(https\:\/\/youtube)|^(https\:\/\/www\.youtube)|^(https\:\/\/player\.vimeo)/gi;

function getMediaType(properties = {}, mediaImage = '') {
	const { mediatype, location = '' } = properties;

	//location = legacy
	const imageUrl = mediaImage || location;
	const imageExtension = imageUrl.split('.').pop();

	if (mediatype === 'image' && allowedImageExtensions.indexOf(imageExtension) > -1) {
		return 'image';
	}

	if (['youtube', 'vimeo'].indexOf(mediatype) > -1 && location.match(allowedVideoRegex)) {
		return 'video';
	}
}

function getMediaStyle(properties = {}, mediaType) {
	if (mediaType === 'image') {
		return {
			textAlign: properties.media_align ? properties.media_align : 'left'
		};
	} else if (mediaType === 'video') {
		return {
			width: properties.media_width,
			margin:
				properties.media_align === 'right'
					? '0 0 0 auto'
					: properties.media_align === 'center'
						? 'auto'
						: '0'
		};
	} else {
		return null;
	}
}

function Media({ block, mediaType }) {
	const { properties } = block;

	if (block.type === 'img') {
		//thanks page in conversational
		const imageUrl = block.image?.url ?? block.url;
		const imageAlt = block.image?.alt ?? block.properties?.alt ?? '';

		return (
			<img
				src={imageUrl}
				title={block.properties?.alt ?? block.title ?? ''}
				alt={imageAlt}
				style={{
					height: 'auto',
					width: '100%'
				}}
			/>
		);
	} else if (mediaType === 'image') {
		const imageUrl = getImageUri(block.image?.url ?? properties.location);
		const imageAlt = block.image?.alt ?? block.properties?.alt ?? '';

		return (
			<img
				title={imageAlt ?? block.title ?? ''}
				alt={imageAlt}
				src={imageUrl}
				style={{
					height: 'auto',
					width: properties.media_width || '100%'
				}}
			/>
		);
	} else if (mediaType === 'video') {
		return (
			<div
				style={{
					padding: '56.25% 0 0 0',
					position: 'relative'
				}}
			>
				<iframe
					title={block.title}
					class="video-frame"
					src={properties.location}
					frameborder={0}
					allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
					style={{
						height: '100%',
						width: '100%',
						position: 'absolute',
						top: 0,
						left: 0
					}}
				/>
			</div>
		);
	}
}

export default memo(
	function Multimedia({ block }) {
		const mediaType = getMediaType(block.properties, block.image?.url ?? '');

		const mediaStyle = getMediaStyle(block.properties, mediaType);

		return (
			<div
				id={`multimedia_${block.id}`}
				style={mediaStyle}
				class="section-multimedia"
			>
				<Media
					block={block}
					mediaType={mediaType}
				/>
			</div>
		);
	},
	() => false
);
